import React, { Fragment, useEffect, useState } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

import { getFormValues } from 'redux-form';

import {
    AgentsCard
} from './fields';

import {
    GET_ONE,
    GET_LIST,
    provider,
} from '../../_utils';


const not = (a, b) => {
    return a.filter(value => b.login!==value.login);
}

const InboundSettings = ({queue, changeAgents}) => {
    const [left, setLeft] = useState([]);
    const [right, setRight] = useState([]);
    
    useEffect(()=>{
        const  getQueue = async () =>{
            const { data, status } = await provider(GET_ONE, '/dashboard/queue', queue.id);
            if(status === 200){
                const agents = await getAgents();
                const usedAgents = [];
                for (var i = 0; i < data.operators.length; i++) {
                    let agent = data.operators[i];
                    const agentData = agents.find( a => a.login === agent.DisplayName);
                    if(agentData){
                        usedAgents.push(agentData)
                    }else{
                        usedAgents.push({ login: agent.DisplayName, fullname: ""})
                    }
                };
                let notUsedAgents = agents.filter( agent => !usedAgents.find( a => a.login===agent.login)&&agent.login).sort( (a,b) => parseInt(a.login.match(/\d+/)) - parseInt(b.login.match(/\d+/)));
                usedAgents.sort( (a,b) => parseInt(a.login.match(/\d+/)) - parseInt(b.login.match(/\d+/)));
                setLeft(notUsedAgents);
                setRight(usedAgents);
            }
        }

        // const  getStatistics = async () =>{
        //     const { data, status } = await provider(
        //         GET_LIST,
        //         '/infra/statistics/inbounds',
        //         {
        //             filter: {status: 'Active', },
        //             sort: { field: 'login', order: 'DESC' },
        //             pagination: { page: 1, perPage: 1000 },
        //         }
        //     );
        //     if(status === 200){
        //         const agents = await getAgents();
        //         const usedAgents = [];
        //         for (var i = 0; i < data.operators.length; i++) {
        //             let agent = data.operators[i];
        //             const agentData = agents.find( a => a.login === agent.DisplayName);
        //             if(agentData){
        //                 usedAgents.push(agentData)
        //             }else{
        //                 usedAgents.push({ login: agent.DisplayName, fullname: ""})
        //             }
        //         };
        //         let notUsedAgents = agents.filter( agent => !usedAgents.find( a => a.login===agent.login)&&agent.login).sort( (a,b) => parseInt(a.login.match(/\d+/)) - parseInt(b.login.match(/\d+/)));
        //         usedAgents.sort( (a,b) => parseInt(a.login.match(/\d+/)) - parseInt(b.login.match(/\d+/)));
        //         setLeft(notUsedAgents);
        //         setRight(usedAgents);
        //     }
        // }

        const getAgents = async () => {
            const { data } = await provider(
                GET_LIST,
                '/operators',
                {
                    filter: {status: 'Active', },
                    sort: { field: 'login', order: 'DESC' },
                    pagination: { page: 1, perPage: 1000 },
                }
            );
            return data;
        }
        if(queue){
            getQueue();
        }
    },[queue]);

    const handleToggle = value => () => {
        const leftIndex = left.find( l => l.login===value.login);
        let newLeft = [...left];
        let newRight = [...right];
        if(leftIndex){
            newRight = newRight.concat([value]);
            newLeft = not(newLeft, value);
        }else{
            if(value.fullname&&value.fullname.length>0){
                newLeft = newLeft.concat([value]);
            }
            newRight = not(newRight, value);
        }
        newLeft.sort( (a,b) => parseInt(a.login.match(/\d+/)) - parseInt(b.login.match(/\d+/)));
        newRight.sort( (a,b) => parseInt(a.login.match(/\d+/)) - parseInt(b.login.match(/\d+/)));
        setLeft(newLeft);
        setRight(newRight);
        changeAgents(newRight);
        return;
    };

    return(
        <Fragment>
            {queue ?
                <AgentsCard left={left} right={right}  handleToggle={handleToggle}/> 
                :
                <div/>
            }
        </Fragment>
    );
}

const mapStateToProps = (state, props) => {
    var recordLiveValues = getFormValues('inbound')(state);
    return { form: recordLiveValues};
};

export default compose(
    connect(mapStateToProps),
)(InboundSettings);

